export default "__VITE_ASSET__Bgya5p69__"